/* eslint-disable prettier/prettier */
export const loadScript = (url, callback) => {
  const script: any = document.createElement('script');
  script.type = 'text/javascript';

  if (script.readyState) {
    //IE
    script.onreadystatechange = function () {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    //Others
    script.onload = function () {
      callback();
    };
  }

  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
};

export interface RappiCity {
  id: string;
  country: string;
  city: string;
  cityCode: string;
  name: string;
  statecode: string;
}

export const convertCities = (external_file_Cities): RappiCity[] => {
  const cities: RappiCity[] = external_file_Cities
    ? external_file_Cities.map((item) => {
      const splitCity = item.split(',');
      let splitCountry = splitCity[1].split('(');
      let code = splitCountry[1] ? splitCountry[1].slice(0, splitCountry[1].length - 1) : '';
      let country = splitCountry[0].replace(/^\s+|\s+$/g, '');
      if (splitCity.length > 2) {
        splitCountry = splitCity[2].split('(');
        code = splitCountry[1] ? splitCountry[1].slice(0, splitCountry[1].length - 1) : '';
        country = splitCountry[0].replace(/^\s+|\s+$/g, '');
      }
      return {
        id: code,
        country: country,
        city: splitCity[0],
        cityCode: code,
        name: `${splitCity[0]}, ${country}`,
        statecode: `${splitCity.length > 2 ? splitCity[1].replace(/^\s+|\s+$/g, '') : ''}`,
      } as RappiCity;
    })
    : [];

  return cities;
};

export const loadCities = (city: string, country: string, language: string): Promise<RappiCity[]> => {
  const JSFILE = `https://d14xsmsn4vzz2n.cloudfront.net/autocompletes/rappi/allcities-${language}.js`;                  
  return new Promise<RappiCity[]>(async (resolve, reject) => {
    try {
      loadScript(JSFILE, () => {
        const cities = convertCities(window['external_file_AllCities']);
        //window.external_file_AllCities.filter(item => item.match(/Salvador(.*)?, Brasil \([a-zA-Z0-9]+\)/gi));
        resolve(cities);
      });
    } catch (e) {
      reject(e);
    }
  });
};

export const getCityCode = (cities: RappiCity[], city: string, country: string): string => {
  const found = cities.filter(
    (c) => normalizeText(c.city) === normalizeText(city) && normalizeText(c.country) === normalizeText(country),
  );
  if (found && found.length > 0) {
    return found[0].cityCode;
  }
  return '';
};

export function normalizeText(text: string): string {
  const from = 'ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç',
    to = 'AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc',
    mapping = {};

  for (let i = 0, j = from.length; i < j; i++) mapping[from.charAt(i)] = to.charAt(i);
  const ret: any = [];
  for (let i = 0, j = text.length; i < j; i++) {
    const c = text.charAt(i);
    if (mapping.hasOwnProperty(text.charAt(i))) ret.push(mapping[c]);
    else ret.push(c);
  }

  const url = ret
    .join('')
    .replace(/[^-A-Za-z0-9]+/g, '-')
    .toLowerCase();
  let actualCharIsSpecialCharacter = false;
  let lastChariIsSpecialCharacter = false;
  let newUrl = '';
  for (let i = 0; i < url.length; i++) {
    // eslint-disable-next-line
    actualCharIsSpecialCharacter = url.charAt(i).match(/^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/) !== null;
    if (i > 0)
      // eslint-disable-next-line
      lastChariIsSpecialCharacter = url.charAt(i - 1).match(/^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/) !== null;
    newUrl += (i === 0 || i === url.length - 1) && actualCharIsSpecialCharacter ? '' : url.charAt(i);
    if (lastChariIsSpecialCharacter && actualCharIsSpecialCharacter) newUrl = newUrl.slice(0, newUrl.length - 1);
  }
  return newUrl;
}

export const fixCity = (cityName: string): string => {
  if (cityName.indexOf('Cartagena') !== -1) {
    return 'Cartagena';
  }

  return cityName;
};
